import {AbilityBuilder} from "@casl/ability";
import {CompanyRole} from "@/app/auth/roles";
import {CompanyAbility, UserWithRoles,} from "@/app/auth/abilities";
import {DocumentTemplate} from "@/pb/api/devplan/types/templates";
import {DocumentTemplatePermissions, DocumentTemplatesPermissions} from "@/pb/api/devplan/types/permissions";

const categoryToRoles: Record<string, CompanyRole[]> = {
  'product': [CompanyRole.PRODUCT],
  'engineering': [CompanyRole.ENGINEERING],
  'marketing': [CompanyRole.MARKETING],
}

export function defineDocumentAbilities(
  user: UserWithRoles,
  builder: AbilityBuilder<CompanyAbility>,
  companyId: number,
  role: CompanyRole,
) {
  const {can} = builder
  const templateIds = Object.keys(user.permissions.documentTemplates?.templatePermissions ?? {})
  templateIds.forEach(templateId => {
    const perm = user.permissions.documentTemplates?.templatePermissions?.[templateId];
    const allowedRoles = perm?.allowedRoles ?? []
    const allowed = allowedRoles.length === 0 || allowedRoles.includes(role);
    if (allowed) {
      can('manage', 'Document', {companyId, templateId})
      can('create', 'ChatMessage', {companyId, templateId})
    } else {
      if (perm?.partOfDraft) {
        // eslint-disable-next-line
        can('manage', ['Document', 'ChatMessage'], {companyId, templateId, isDraftPart: true} as any)
      }
    }
  })
}

export function getDocumentTemplatePermissions(templates: DocumentTemplate[]): DocumentTemplatesPermissions {
  const templatePermissions: Record<string, DocumentTemplatePermissions> = {}
  templates.forEach(t => {
    const roles = t.meta?.categories?.flatMap(c => categoryToRoles[c] ?? []) ?? []
    const allowedRoles: string[] = [...new Set(roles)]
    templatePermissions[t.id] = {allowedRoles, partOfDraft: !!t.meta?.partOfDraft}
  })
  return {templatePermissions}
}